import apiClient from "./apiClient";
import { SubcontractCalendarEntry } from "../types/subcontractCalendarTypes";

/**
 * Obtiene las asignaciones diarias de empresas subcontratistas.
 * Mismo contrato que /StaffCalendar y /EquipmentCalendar: los tres filtros son opcionales.
 */
export const getSubcontractCalendar = async (
    startDate?: string,
    finishDate?: string,
    projectId?: number
): Promise<SubcontractCalendarEntry[]> => {
    try {
        const response = await apiClient.get('/SubcontractCalendar', {
            params: {
                ...(startDate && { startDate }),
                ...(finishDate && { finishDate }),
                ...(projectId && { projectId })
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error al obtener el calendario de subcontratos:', error);
        throw new Error('Error al obtener el calendario de subcontratos.');
    }
};
